import fetch from 'isomorphic-fetch'

const API_URL_AVT = import.meta.env.VITE_AVT_API_URL

const createRequestBody = (requestObj) => {
  return {
    method: requestObj.method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(requestObj.body)
  }
}

const getParams = async () => {
  const requestUrl = `${API_URL_AVT}/odin/api/params`

  const requestBody = await createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

export { getParams }
